<template>
  <div>
    <div class="member_center_back">
      <div class="dsm-container">
        <div class="left-layout">
          <div class="dsm-sidebar">
            <div class="dl">
              <div class="dt">
                <h3 key="trade"><i class="iconfont"></i>订单中心</h3>
              </div>
              <div class="dd">
                <ul>
                  <li>
                    <router-link to="/user/order">商城订单</router-link>
                  </li>
                  <li>
                    <a href="javascript:void(0);">积分订单</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="dl">
              <div class="dt">
                <h3 key="info"><i class="iconfont"></i>会员中心</h3>
              </div>
              <div class="dd">
                <ul>
                  <li>
                    <router-link to="/user/memberinfo">账户信息</router-link>
                  </li>
                  <li>
                    <router-link to="/user/address">收货地址</router-link>
                  </li>
                  <li>
                    <router-link to="/user/collect">我的收藏</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="right-layout">
          <div class="tabmenu"></div>
          <div class="mc-left">
            <div class="mc-user">
              <div class="mc-user-card fl">
                <div class="circle-top"></div>
                <div class="circle-bottom"></div>
                <div class="user-head fl">
                  <div class="user-canvas ">
                    <span v-if="user.status == 1">已审</span>
                    <span v-else>未审</span>
                    <div class="canvas-bg">
                      <div class="canvas-left">
                        <div></div>
                      </div>
                      <!--起始度数-121deg为0%，增加度数到0deg时半圈结束-->
                      <div class="canvas-right">
                        <div></div>
                      </div>
                      <!--起始度数为为-180deg，增加度数到-59deg时为100%半圈结束-->
                    </div>
                  </div>
                  <p class="user-img">
                    <img :src="user.avatar" />
                  </p>
                </div>
                <div class="mc-user-info fl ">
                  <div class="name" v-if="user.mer_name">
                    {{ user.mer_name }}
                  </div>
                  <div class="name" v-if="!user.mer_name">
                    {{ user.nickname }}
                  </div>
                  <a href="javascript:void(0);" class="mc-user-btn">账户信息</a>
                </div>
              </div>

              <div class="mc-user-huaban fl">
                <ul>
                  <li>
                    <a href="javascript:void(0);" class="p-icon bg-blue iconfont"></a>
                    <p class="p-dec">积分</p>
                    <p class="p-price">
                      <span class="">{{ user.integral }}</span>分
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div class="mc-order-portal">
              <ul>
                <li class="portal-icon-5">
                  <router-link :to="{ path: '/user/order', query: { type: 1 } }">
                    <span class="iconfont">
                      <b v-if="orderStatusNum.unshipped_count">
                        {{ orderStatusNum.unshipped_count}}</b></span>待发货</router-link>
                </li>
                <li class="portal-icon-2">
                  <router-link :to="{ path: '/user/order', query: { type: 2 } }"><span class="iconfont"><b
                        v-if="orderStatusNum.received_count">{{
                        orderStatusNum.received_count
                      }}</b></span>待收货</router-link>
                </li>
                <li class="portal-icon-3">
                  <router-link :to="{ path: '/user/order', query: { type: 3 } }"><span class="iconfont"><b
                        v-if="orderStatusNum.evaluated_count">{{
                        orderStatusNum.evaluated_count
                      }}</b></span>待评价</router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="mc-right">
            <div class="mc-security">
              <div class="title">账户安全</div>
              <div class="content" v-if="!user.phone">低</div>
              <div class="content" v-else>高</div>
              <div class="detail">
                <span class="iconfont bg-orange2"></span>绑定手机
                <span class="state fr " v-if="!user.phone">未绑定</span>
                <span class="state fr " v-else>{{ user.phone }}</span>
              </div>
            </div>
          </div>
          <div class="mc-left append">
            <div class="pt20">
              <div class="mc-title">
                <h3>我的足迹</h3>
              </div>
              <div class="mynews-list-area my_center service_type_4 " v-for="(item, index) in visit" :key="index">
                <div class="m-image">
                  <img :src="item.image" />
                </div>
                <div class="m-title">
                  <em class="m-info">{{ item.store_name }}</em>
                  <em class="m-name">浏览于</em>
                  <em class="m-time">{{ item.add_time }}</em>
                </div>
                <p class="m-detail">{{ item.keyword }}</p>
                <router-link :to="{ path: '/good/detail/' + item.product_id }" class="button-1 mynews-list-btn">查看详情
                </router-link>
              </div>
            </div>
          </div>
          <div class="mc-right append">
            <div class="pt20">
              <div class="mc-title">
                <h3>商品收藏</h3>
              </div>
              <div class="mc-list" v-if="!collect_goods.length">
                <dl class="null-tip pb10">
                  <dt class="iconfont"></dt>
                  <dd>
                    <h4>您还没有收藏商品</h4>
                  </dd>
                </dl>
              </div>
              <div class="mc-list" v-if="collect_goods.length">
                <div class="mc-item" v-for="(item, index) in collect_goods" :key="index">
                  <router-link :to="{ path: '/good/detail/' + item.pid }" :title="item.store_name"><img
                      :src="item.image" /></router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="right-layout">
            <div id="member_center_box" class="dsm-index-container"></div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<script>
  import '@/assets/styles/member.css';
  import {
    getUser,
    visit,
    getCollectUser
  } from '@/api/user';
  export default {
    name: 'Index',
    components: {},
    props: {},
    data: function () {
      return {
        user: [],
        visit: [],
        collect_goods: [],
        orderStatusNum: {},
        page: 1,
        limit: 15
      };
    },
    mounted: function () {
      this.getData();
    },
    methods: {
      getData() {
        var that = this;
        getUser()
          .then((res) => {
            that.user = res.data;
            that.orderStatusNum = that.user.orderStatusNum
          })
          .catch((res) => {
            that.$dialog.error(res.msg);
          });
        visit()
          .then((res) => {
            that.visit = res.data.list;
          })
          .catch((res) => {
            that.$dialog.error(res.msg);
          });
        getCollectUser(this.page, this.limit)
          .then((res) => {
            that.collect_goods = res.data;
          })
          .catch((res) => {
            that.$dialog.error(res.msg);
          });
      },
    },
  };
</script>

<style scoped>
</style>
